/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 納品（受入）可能フラグ（水曜日）
 * @export
 * @interface EnableArrivalWed
 */
export interface EnableArrivalWed {
}

/**
 * Check if a given object implements the EnableArrivalWed interface.
 */
export function instanceOfEnableArrivalWed(value: object): value is EnableArrivalWed {
    return true;
}

export function EnableArrivalWedFromJSON(json: any): EnableArrivalWed {
    return EnableArrivalWedFromJSONTyped(json, false);
}

export function EnableArrivalWedFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableArrivalWed {
    return json;
}

export function EnableArrivalWedToJSON(json: any): EnableArrivalWed {
    return EnableArrivalWedToJSONTyped(json, false);
}

export function EnableArrivalWedToJSONTyped(value?: EnableArrivalWed | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

